import React, { useState } from 'react';
import { LegalModal } from './LegalModal';
export function Footer() {
  const [activeModal, setActiveModal] = useState<'terms' | 'privacy' | null>(null);
  const closeModal = () => setActiveModal(null);
  return <footer className="bg-[#5C4B3A] py-12 px-6 text-center" data-id="element-25">
      <div className="max-w-4xl mx-auto" data-id="element-26">
        <h3 className="font-heading text-2xl font-bold text-[#FFF8F0] mb-4" data-id="element-27">
          Lonchera Realista
          <p data-id="element-28">15-Min</p>
        </h3>
        <p className="text-[#FFF8F0]/70 text-sm mb-8" data-id="element-29">
          Nutrición inteligente para madres ocupadas.
        </p>
        <div className="h-px w-full bg-[#FFF8F0]/10 mb-8" data-id="element-30"></div>
        <div className="flex flex-col md:flex-row justify-center items-center space-y-4 md:space-y-0 md:space-x-8 text-sm text-[#FFF8F0]/60" data-id="element-31">
          <p data-id="element-32">
            &copy; {new Date().getFullYear()} Lonchera Realista. Todos los
            derechos reservados.
          </p>

          <p className="text-center max-w-2xl" data-id="element-33">
            Este sitio no es parte del sitio web de Facebook o Facebook Inc.
            Además, este sitio NO está respaldado por Facebook de ninguna
            manera.
            <br data-id="element-34" />
            FACEBOOK es una marca registrada de FACEBOOK, Inc.
          </p>
          <div className="flex space-x-4" data-id="element-35">
            <button onClick={() => setActiveModal('terms')} className="hover:text-[#FFF8F0] transition-colors" data-id="element-36">
              Términos y Condiciones
            </button>
            <button onClick={() => setActiveModal('privacy')} className="hover:text-[#FFF8F0] transition-colors" data-id="element-37">
              Política de Privacidad
            </button>
          </div>
        </div>
      </div>

      {/* Terms and Conditions Modal */}
      <LegalModal isOpen={activeModal === 'terms'} onClose={closeModal} title="Términos y Condiciones" data-id="element-38">
        <div className="space-y-6" data-id="element-39">
          <section data-id="element-40">
            <h3 className="text-xl font-bold text-[#2D6A4F] mb-2" data-id="element-41">
              1. Naturaleza del Producto
            </h3>
            <p data-id="element-42">
              "Lonchera Realista 15-Min" es un producto digital en formato PDF.
              Al realizar la compra, se le otorgará acceso inmediato para
              descargar el documento a su dispositivo. No se enviará ningún
              producto físico a su domicilio.
            </p>
          </section>

          <section data-id="element-43">
            <h3 className="text-xl font-bold text-[#2D6A4F] mb-2" data-id="element-44">
              2. Uso Personal y Propiedad Intelectual
            </h3>
            <p data-id="element-45">
              Todo el contenido de esta guía está protegido por derechos de
              autor. Su compra le otorga una licencia de uso estrictamente
              personal y no transferible. Queda terminantemente prohibida la
              reproducción, distribución, reventa, modificación o uso comercial
              de cualquier parte de este material sin el consentimiento expreso
              por escrito.
            </p>
          </section>

          <section data-id="element-46">
            <h3 className="text-xl font-bold text-[#2D6A4F] mb-2" data-id="element-47">
              3. Proceso de Compra y Pago
            </h3>
            <p data-id="element-48">
              Los pagos son procesados a través de plataformas de terceros
              seguras. Al realizar una compra, usted acepta proporcionar
              información actual, completa y precisa. Nos reservamos el derecho
              de rechazar o cancelar cualquier pedido en caso de sospecha de
              fraude o transacciones no autorizadas.
            </p>
          </section>

          <section data-id="element-49">
            <h3 className="text-xl font-bold text-[#2D6A4F] mb-2" data-id="element-50">
              4. Política de Reembolso
            </h3>
            <p data-id="element-51">
              Debido a la naturaleza digital y de acceso inmediato del producto,
              todas las ventas son finales. No se emitirán reembolsos una vez
              que el archivo PDF haya sido descargado, a menos que la ley local
              del consumidor exija lo contrario. Si experimenta problemas
              técnicos para acceder a su compra, contáctenos para recibir
              asistencia.
            </p>
          </section>

          <section data-id="element-52">
            <h3 className="text-xl font-bold text-[#2D6A4F] mb-2" data-id="element-53">
              5. Limitación de Responsabilidad
            </h3>
            <p data-id="element-54">
              La información proporcionada en "Lonchera Realista 15-Min" tiene
              fines puramente educativos e informativos. No constituye consejo
              médico, nutricional o pediátrico profesional. Siempre consulte con
              el pediatra o nutricionista de su hijo antes de realizar cambios
              significativos en su dieta, especialmente si existen alergias o
              condiciones médicas preexistentes.
            </p>
          </section>

          <section data-id="element-55">
            <h3 className="text-xl font-bold text-[#2D6A4F] mb-2" data-id="element-56">
              6. Modificaciones a los Términos
            </h3>
            <p data-id="element-57">
              Nos reservamos el derecho de actualizar o modificar estos términos
              en cualquier momento sin previo aviso. El uso continuo del
              producto o sitio web después de cualquier cambio constituye su
              aceptación de los nuevos términos.
            </p>
          </section>

          <section data-id="element-58">
            <h3 className="text-xl font-bold text-[#2D6A4F] mb-2" data-id="element-59">
              7. Contacto
            </h3>
            <p data-id="element-60">
              Para cualquier pregunta relacionada con estos Términos y
              Condiciones, por favor contáctenos en:
              soporte@loncherarealista.com
            </p>
          </section>
        </div>
      </LegalModal>

      {/* Privacy Policy Modal */}
      <LegalModal isOpen={activeModal === 'privacy'} onClose={closeModal} title="Política de Privacidad" data-id="element-61">
        <div className="space-y-6" data-id="element-62">
          <section data-id="element-63">
            <h3 className="text-xl font-bold text-[#2D6A4F] mb-2" data-id="element-64">
              1. Información que Recopilamos
            </h3>
            <p data-id="element-65">
              Al realizar una compra o interactuar con nuestro sitio, podemos
              recopilar información personal como: nombre completo, dirección de
              correo electrónico e información de pago. Los datos de pago son
              procesados directamente por nuestras pasarelas de pago seguras;
              nosotros no almacenamos los números de su tarjeta de crédito.
            </p>
          </section>

          <section data-id="element-66">
            <h3 className="text-xl font-bold text-[#2D6A4F] mb-2" data-id="element-67">
              2. Uso de la Información
            </h3>
            <p data-id="element-68">Utilizamos la información recopilada para:</p>
            <ul className="list-disc pl-5 mt-2 space-y-1" data-id="element-69">
              <li data-id="element-70">
                Procesar su pago y entregar el producto digital adquirido.
              </li>
              <li data-id="element-71">Enviar confirmaciones de compra y recibos.</li>
              <li data-id="element-72">Proporcionar soporte al cliente.</li>
              <li data-id="element-73">
                Enviar actualizaciones sobre el producto o correos electrónicos
                promocionales (de los cuales puede darse de baja en cualquier
                momento).
              </li>
            </ul>
          </section>

          <section data-id="element-74">
            <h3 className="text-xl font-bold text-[#2D6A4F] mb-2" data-id="element-75">
              3. Protección de Datos
            </h3>
            <p data-id="element-76">
              Implementamos medidas de seguridad estándar de la industria para
              proteger su información personal contra acceso no autorizado,
              alteración, divulgación o destrucción. Sin embargo, ningún método
              de transmisión por Internet es 100% seguro.
            </p>
          </section>

          <section data-id="element-77">
            <h3 className="text-xl font-bold text-[#2D6A4F] mb-2" data-id="element-78">
              4. Cookies y Tecnologías Similares
            </h3>
            <p data-id="element-79">
              Nuestro sitio web utiliza cookies para mejorar la experiencia del
              usuario, analizar el tráfico del sitio y personalizar el
              contenido. Puede configurar su navegador para rechazar todas las
              cookies, pero esto podría limitar algunas funcionalidades del
              sitio.
            </p>
          </section>

          <section data-id="element-80">
            <h3 className="text-xl font-bold text-[#2D6A4F] mb-2" data-id="element-81">
              5. Compartir Información con Terceros
            </h3>
            <p data-id="element-82">
              No vendemos, comercializamos ni alquilamos su información personal
              a terceros. Solo compartimos información con proveedores de
              servicios de confianza (como procesadores de pago y plataformas de
              envío de correos) que nos asisten en la operación de nuestro
              negocio, siempre bajo estrictos acuerdos de confidencialidad.
            </p>
          </section>

          <section data-id="element-83">
            <h3 className="text-xl font-bold text-[#2D6A4F] mb-2" data-id="element-84">
              6. Sus Derechos
            </h3>
            <p data-id="element-85">
              Usted tiene derecho a acceder, corregir, actualizar o solicitar la
              eliminación de su información personal. Para ejercer estos
              derechos, comuníquese con nosotros a través del correo electrónico
              proporcionado abajo.
            </p>
          </section>

          <section data-id="element-86">
            <h3 className="text-xl font-bold text-[#2D6A4F] mb-2" data-id="element-87">
              7. Cambios a esta Política
            </h3>
            <p data-id="element-88">
              Podemos actualizar esta Política de Privacidad periódicamente. Le
              notificaremos sobre cambios significativos publicando la nueva
              política en esta página.
            </p>
          </section>

          <section data-id="element-89">
            <h3 className="text-xl font-bold text-[#2D6A4F] mb-2" data-id="element-90">
              8. Contacto
            </h3>
            <p data-id="element-91">
              Si tiene preguntas o inquietudes sobre nuestra Política de
              Privacidad o el manejo de sus datos, contáctenos en:
              soporte@loncherarealista.com
            </p>
          </section>
        </div>
      </LegalModal>
    </footer>;
}